import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import _ from 'lodash';
import Steps from './components/steps';
import Content from './components/content';
import Navigation from './components/navigation';
import './index.css';

class Wizard extends Component {
	constructor(props)
   {
		super(props)   
		this.onHandleGoNext = this.onHandleGoNext.bind(this)
		this.onHandleGoPrevious = this.onHandleGoPrevious.bind(this)
		this.onHandleGoTo = this.onHandleGoTo.bind(this)
	}

	componentWillUnmount()
	{
		this.props.onUnmount();
	}

	onHandleGoNext() {
		this.props.onNext();
	}
	
	onHandleGoPrevious() {
		this.props.onPrevious();
	}
	
	onHandleGoTo(step) {
		this.props.onGoTo(step);
	}

	render() {
		const { steps,saveComponentState  } = this.props;
		const currentStep = _.find(steps,{ 'current': true });
		const current = currentStep !== undefined ? currentStep.sequence : 1;
		
		return(
			<div className="panel panel-default">
				<div className="panel-heading">
					<Steps steps={this.props.steps} goTo={this.onHandleGoTo} />
				</div>
				<div className="panel-body">
					<Content StepComponent={this.props.component} saveComponentState={saveComponentState}  onComponentStateSaved={this.props.onComponentStateSaved} />
				</div>
				<div className="panel-footer white-background">
					<Navigation goNext={this.onHandleGoNext}  goPrevious={this.onHandleGoPrevious}  currentStep={current} maxSteps={steps.length} saveComponentState={saveComponentState} />
				</div>
			</div>
		)
	}
}
Wizard.propTypes = {
  steps: PropTypes.array,
  component: PropTypes.func,
  onNext: PropTypes.func,
  onPrevious: PropTypes.func,
  onGoTo: PropTypes.func,
  saveComponentState: PropTypes.bool,
  onComponentStateSaved: PropTypes.func,
  onUnmount: PropTypes.func,
}
export default Wizard


// WEBPACK FOOTER //
// ./src/components/common/wizard/index.js